<template>
    <div>
        <Bar :data="chartData" :options="chartOptions" />
    </div>
</template>

<script>
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend
} from 'chart.js';
import { Bar } from 'vue-chartjs';
import { hexToRgbA } from '../utils/helper';
import moment from 'moment';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default {
    name: 'Barchart',
    components: {
        Bar
    },
    props: {
        statistics: Object,
        filterVehicle: String,
        filterBrand: String,
        filterYear: Array
    },
    data() {
        return {
            chartOptions: {
                aspectRatio: 1,
                plugins: {
                    tooltip: {
                        backgroundColor: '#707070',
                        bodyFont: {
                            family: 'Roboto',
                            size: 11
                        },
                        bodySpacing: 10,
                        borderColor: '#707070',
                        padding: 10,
                        cornerRadius: 4,
                        displayColors: false,
                        mode: 'index',
                        position: 'nearest',
                        titleFont: {
                            family: 'Roboto',
                            size: 13
                        },
                        titleMarginBottom: 20
                    },
                    legend: {
                        align: 'start',
                        labels: {
                            fontColor: 'white',
                            font: {
                                family: 'Roboto',
                                size: 8
                            },
                            padding: 10,
                            boxWidth: 20
                        },
                        position: 'bottom',
                        onClick: e => e.stopPropagation()
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: 'white',
                            font: {
                                family: 'Roboto',
                                size: 8
                            },
                            beginAtZero: true,
                            callback: this.labelFormatter
                        },
                        stacked: true,
                        grid: {
                            color: 'transparent'
                        }
                    },
                    y: {
                        ticks: {
                            color: 'white',
                            font: {
                                family: 'Roboto',
                                size: 8
                            },
                            beginAtZero: true,
                            callback: this.labelFormatter
                        },
                        stacked: true,
                        grid: {
                            color: 'transparent'
                        }
                    }
                }
            }
        };
    },
    methods: {
        labelFormatter(label) {
            return Math.floor(label) === label ? label : null;
        }
    },
    computed: {
        chartData() {
            const datasets = [];

            this.statistics.forEach(brand => {
                if (
                    this.filterBrand &&
                    brand.name.toLowerCase() !== this.filterBrand
                )
                    return;

                brand.years.forEach((year, index) => {
                    if (
                        this.filterYear.length > 0 &&
                        !this.filterYear.includes(index)
                    )
                        return;

                    const data = year.months.map(m => {
                        if (this.filterVehicle) {
                            return m[this.filterVehicle];
                        } else {
                            return m.cuv + m.ww;
                        }
                    });

                    const colors = year.months.map(() =>
                        hexToRgbA(brand.color, (index + 1) / brand.years.length)
                    );

                    datasets.push({
                        stack: year.name,
                        label: `${brand.name.toUpperCase()} ${year.name}`,
                        data: data,
                        backgroundColor: colors,
                        borderColor: colors
                    });
                });
            });

            return {
                labels: Array.from({ length: 12 }, (_, i) =>
                    moment()
                        .locale(this.$i18n.locale)
                        .month(i)
                        .format('MMM')
                ),
                datasets
            };
        }
    },
    watch: {
        filterVehicle() {
            this.$nextTick(() => {
                this.chartData = this.getChartData();
            });
        },
        filterBrand() {
            this.$nextTick(() => {
                this.chartData = this.getChartData();
            });
        },
        filterYear() {
            this.$nextTick(() => {
                this.chartData = this.getChartData();
            });
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.chartData = this.getChartData();
        });
    }
};
</script>
